import { render, staticRenderFns } from "./pi-tabs.vue?vue&type=template&id=0e90c880&"
import script from "./pi-tabs.vue?vue&type=script&lang=js&"
export * from "./pi-tabs.vue?vue&type=script&lang=js&"
import style0 from "./pi-tabs.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports